export default "__VITE_ASSET__af3$W_mU__"